// Atlas History brand constants — single source of truth for logo + tagline.
// Logo is served from /public/brand/ so it never depends on an external CDN.
export const ATLAS_LOGO_URL = '/brand/atlas-logo.png';

export const ATLAS_NAME = 'Atlas History';
export const ATLAS_SUBTITLE = 'Editorial Archive';
export const ATLAS_TAGLINE = 'Everything history teachers need.';
export const ATLAS_SUBTAGLINE = 'Resources. Lessons. Standards. Impact.';

// Per-grade subject-color accents. Single source of truth for any card/badge
// that needs to telegraph WHICH subject a unit belongs to at a glance.
// Mapping mirrors the SubjectHub grade -> subject groupings.
export const GRADE_ACCENT = {
  7:  { name: 'Civics & Govt',   hex: '#7A5C3F', subject: 'Civics' },
  8:  { name: 'US History',      hex: '#1D5BAC', subject: 'US History' },
  9:  { name: 'World History',   hex: '#4A6B8A', subject: 'World History' },
  10: { name: 'World History',   hex: '#4A6B8A', subject: 'World History' },
  11: { name: 'US History',      hex: '#1D5BAC', subject: 'US History' },
  12: { name: 'Government',      hex: '#7A93AC', subject: 'Government' },
};

export const gradeAccent = (grade) => GRADE_ACCENT[grade] || { name: '—', hex: '#7A93AC', subject: 'History' };
